<template>
  <div>
    <div class="d-flex justify-content-between mb-3 pb-1">
      <DateRange :update="dateRange" opens="right" :startDate="filter.startDate" :endDate="filter.endDate" />
      <div>
        <b-button variant="primary" size="sm" @click="exportPDF" class="export-btn">
          {{ 'PDF' | i18n }}
        </b-button>
      </div>
    </div>
    <Table
      :update="getPage"
      :columns="columns"
      :rows="rows"
      :filter="filter"
      :update-filter="updateFilter"
      :loading-instance="loadingInstance"
      :set-loading-instance="setLoadingInstance"
      class="overflow-auto pr-1"
      table-name="plantInputTable"
    />
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import api from '../../../api';
import { AuthMixin } from '../../../../mixins';
import DateRange from '../../common/date-range';
import Table from '../../common/table';

export default {
  title: 'Anlageninput kumuliert',
  components: { DateRange, Table },
  mixins: [AuthMixin],
  data() {
    return {
      cummulation: api.cummulation,
      loadingInstance: null,
      rows: [],
      filter: {
        page: 1,
        limit: 20,
        totalCount: 0,
        sortBy: '',
        sortOrder: '',
        startDate: moment().startOf('month').add(3, 'hour'),
        endDate: moment(),
      },
      details: [
        {
          header: 'DETAILS',
          content: [
            { value: 'date', name: 'Date' },
            { value: 'quantity', name: 'Summe Inputmenge' },
          ],
        },
      ],
      columns: [
        {
          field: 'date',
          title: this.$translate('Date'),
          key: '9',
          sortBy: '',
          align: 'left',
          width: '50%',
          renderBodyCell: ({ row }, h) => {
            const date = row.date.toString();
            return <div class={`status-cell`}>{moment(date).format('DD.MM.yyyy')}</div>;
          },
        },
        {
          field: 'quantity',
          title: this.$translate('Summe Inputmenge'),
          key: '6',
          sortBy: '',
          align: 'left',
          width: '50%',
          renderBodyCell: ({ row }, h) => {
            const quantity = parseFloat(row.quantity);
            return <div style="text-align: right; width: 165px;">{quantity.toLocaleString('de-De')}</div>;
          },
        },
      ],
    };
  },
  methods: {
    async getPage() {
      try {
        this.startLoading();
        const { page, limit, sortBy, sortOrder, startDate, endDate } = this.filter;
        const ctx = {
          page,
          limit,
          sortBy,
          sortOrder,
        };
        if (startDate) {
          ctx.startDate = moment(startDate).format('yyyy-MM-DD');
        }
        if (endDate) {
          ctx.endDate = moment(endDate).format('yyyy-MM-DD');
        }
        const response = await this.cummulation.get(ctx);
        this.filter.totalCount = response.totalCount;
        this.stopLoading();
        const data = [];
        response.data.forEach((el, idx) => {
          if (idx === 0) {
            data.push(el);
          } else {
            data.push({ ...el, quantity: el.quantity + data[idx - 1].quantity });
          }
        });
        this.rows = data;
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
    updateFilter(f) {
      this.filter = {
        ...this.filter,
        ...f,
      };
    },
    setLoadingInstance(loadingInstance) {
      this.loadingInstance = loadingInstance;
    },
    startLoading() {
      this.loadingInstance.show();
    },
    stopLoading() {
      this.loadingInstance.close();
    },
    dateRange(d) {
      this.filter.startDate = d.startDate;
      this.filter.endDate = d.endDate;
      this.getPage();
    },
    async exportPDF() {
      try {
        const { page, limit, sortBy, sortOrder, startDate, endDate } = this.filter;
        const ctx = {
          page,
          limit,
          sortBy,
          sortOrder,
        };
        if (startDate) {
          ctx.startDate = startDate;
        }
        if (endDate) {
          ctx.endDate = endDate;
        }
        const baseUrl = axios.defaults.baseURL;
        const auth = this.authStorageService.getAuth();
        const token = auth.access_token;

        fetch(
          `${baseUrl}/api/v1/gmva/cummulation/pdf?page=${page}&limit=${limit}&sortBy=${sortBy}&sortOrder=${sortOrder}&startDate=${startDate}&endDate=${endDate}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
          .then((resp) => resp.blob())
          .then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = `${moment().format('yyyy-MM-DD')}_Anlageninput_kumuliert.pdf`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            this.showNotification({ type: 'success', message: this.$translate('file_has_been_downloaded_successful') });
          })
          .catch((err) => {
            console.log('error', err);
          });
      } catch (err) {
        console.log('err', err);
      }
    },
  },
};
</script>

<style lang="scss"></style>
